import { ArrowUpRight, CalendarDays, Clock3, ExternalLink, MapPin } from 'lucide-react';
import { content, Chapter, Reveal, WhatsAppIcon } from './Shared';

const whatsappUrl = event => `${content.contact.whatsapp.split('?')[0]}?text=${encodeURIComponent(event.interestMessage)}`;

export const Events = ({ onEnquire }) => <section id="events" className="section events-section" data-testid="events-section">
  <div className="wrap">
    <Chapter id="events" intro={content.eventsIntro}/>
    <div className="event-list">{content.events.map((event, index) => <Reveal key={event.id} delay={index * .08}>
      <article className={`event-card ${index % 2 ? 'event-card-reversed' : ''}`} data-testid={`event-card-${index}`}>
        <a href={event.assetUrl} target="_blank" rel="noopener noreferrer" className={`event-media ${event.id === 'nursing-excellence-2026' ? 'portrait' : ''}`} aria-label={`${event.assetLabel} for ${event.title}`} data-testid={`event-asset-link-${index}`}>
          <img src={event.image} alt={event.imageAlt} loading="lazy" data-testid={`event-image-${index}`}/>
          <span>{event.assetLabel}<ExternalLink size={15}/></span>
        </a>
        <div className="event-copy">
          <span className="event-badge" data-testid={`event-badge-${index}`}>{event.badge}</span>
          <h3 data-testid={`event-title-${index}`}>{event.title}</h3>
          <p className="event-subtitle" data-testid={`event-subtitle-${index}`}>{event.subtitle}</p>
          <p className="event-summary" data-testid={`event-summary-${index}`}>{event.summary}</p>
          <div className="event-meta" data-testid={`event-meta-${index}`}>
            <span><CalendarDays size={18}/>{event.date}</span>
            {event.time && <span><Clock3 size={18}/>{event.time}</span>}
            <span><MapPin size={18}/>{event.venue}{event.location ? ` · ${event.location}` : ''}</span>
          </div>
          <div className="event-topics" data-testid={`event-topics-${index}`}>{event.topics.map(topic => <span key={topic}>{topic}</span>)}</div>
          <div className="event-actions">
            <a href="#contact" className="event-enquire" onClick={() => onEnquire?.(event.interestService, event.interestMessage)} data-testid={`event-enquire-${index}`}>Express interest <ArrowUpRight size={17}/></a>
            <a href={whatsappUrl(event)} target="_blank" rel="noopener noreferrer" className="event-whatsapp" data-testid={`event-whatsapp-${index}`}><WhatsAppIcon width={20}/> WhatsApp interest</a>
            <a href={event.assetUrl} target="_blank" rel="noopener noreferrer" className="event-download" data-testid={`event-download-${index}`}>{event.assetLabel}<ExternalLink size={15}/></a>
          </div>
          <small data-testid={`event-asset-note-${index}`}>{event.assetNote}</small>
        </div>
      </article>
    </Reveal>)}</div>
    <p className="events-note" data-testid="events-note">{content.eventsNote}</p>
  </div>
</section>;
